import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuController, NavController } from '@ionic/angular';
import { Socket } from 'ngx-socket-io';
import { Observable, Subject, switchMap } from 'rxjs';
import { catchError, map, takeUntil, tap } from 'rxjs/operators';
import { TieService } from '../../_core/services/tie.service';
import { Tie } from '../../_shared/models/tie.model';

@Component({
  standalone: false,
    selector: 'app-match-details',
    templateUrl: './match-details.page.html',
    styleUrls: ['./match-details.page.scss'],
})
export class MatchDetailsPage implements OnDestroy {
    private tieService = inject(TieService);
    private activatedRoute = inject(ActivatedRoute);
    private socket = inject(Socket);
    private navCtrl = inject(NavController);
    private menuController = inject(MenuController);

    // tie: Tie;
    tieId: string;

    tie = signal<Tie>(undefined);

    constructor() {
        this.activatedRoute.params.pipe(
            takeUntilDestroyed(),
            switchMap(params => this.tieService.getTie(params['tieId'])),
            catchError(() => this.navCtrl.navigateBack('')),
            map(res => res.data)
        ).subscribe(
            async (tie) => {
                this.tie.set(tie);
                this.socket.emit('join-room', this.tieId);
                this.socketSubscriptions();
                await this.menuController.enable(true, 'tracker');
            }
        )
    }

    private readonly destroy$: Subject<void> = new Subject();

    ngOnDestroy(): void {
        this.socket.emit('leave-room', this.tieId);
        this.socket.removeListener('tie-status-updated');

        this.destroy$.next();
        this.destroy$.complete();
    }

    private socketSubscriptions() {
        this.getTieStatus()
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (status: any) => {
                    this.tie.update(state => ({...state, ...{
                        winningSide: status.winningSide,
                        matchStatus: status.matchStatus,
                        score: status.score
                    }}))
                }
            );
    }

    private getTieStatus() {
        const observable = new Observable(
            observer => {
                this.socket.on(
                    'tie-status-updated',
                    data => observer.next(data)
                );
            });
        return observable;
    }

}
